import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { capitalizeFirstLetter, getLocalKey, getUserData, logOutCenter, setLocalKey } from '../../../utils/commonfunction';
import { Link, NavLink, useLocation, useParams } from 'react-router-dom';
import i18next from 'i18next';
// import { SOCKET_CLIENT } from '../../../utils/socket';
import { ROLE } from '../../../utils/Constants';
import logowide from '../../../assets/center/images/logo-h.png';
export default function Header() {
  const { t } = useTranslation();
  const [centerUserData, setCenterUserData] = useState({});
  const [flag, setFlag] = useState(getLocalKey("system_language_flag"));
  const location = useLocation();
  const params = useParams();

  const changeLanguage = (lang, flag) => {
    i18next.changeLanguage(lang);
    setLocalKey("system_language", lang);
    setLocalKey("system_language_flag", flag);
    setFlag(flag);
    const evt = new CustomEvent("language_change");
    document.dispatchEvent(evt);
  }

  useEffect(() => {
    const userData = getUserData(ROLE.CENTER);
    setCenterUserData(userData)
  }, [])

  const isActive = (url = "/") => {
    return window?.location?.pathname?.includes(url);
  }
  // function testSocket() {
  //   let message = prompt("Enter message") || "Hello from socket";
  //   SOCKET_CLIENT.emit('testSocket', message, (error) => {
  //     if (error) {
  //       console.log("*****Socket connection error on notificationSend", error);
  //     }
  //   })
  // }
  // useMemo(() => {
  //   SOCKET_CLIENT.on('testSocketReply', async (response) => {
  //     console.log("Data", response);
  //   });
  //   SOCKET_CLIENT.on('GET-DATA', async (response) => {
  //     console.log("Data", response);
  //   });
  // }, []);
  const handleThemeChange = () => {
    const html = document.querySelector("html");
    if (html.classList.contains("dark-theme")) {
      html.classList.remove("dark-theme");
      setLocalKey("darktheme", "false");
    } else {
      html.classList.add("dark-theme");
      setLocalKey("darktheme", "true");
    }
  }

  const routeTitles = {
    "/center/dashboard/1": "Dashboard",
    "/center/profile": "My Profile",
    "/center/profile/change-password": "Change Password",
    "/center/settings/doctor/1": "Doctors Management",
    "/center/wallet/1": "Wallet Management",
    "/center/settings/doctor/schedule/1": "Schedule Management",
    "/center/patient/1": "Patient Management",
    "/center/patient/appointment/1": "Appointment Management",
    "/center/patient/appointment/view/:id": "Patient Management",
    "/center/patient/medical-history/view": "Medical History"
  };

  const getRouteTitle = (pathname) => {
    if (routeTitles[pathname]) return routeTitles[pathname];
    const matchedRoute = Object.keys(routeTitles).find(route =>
      route.includes(":id") && pathname.startsWith(route.replace(":id", ""))
    );
    return matchedRoute ? routeTitles[matchedRoute] : null;
  };

  const heading = getRouteTitle(location.pathname);

  return (
    <div className='header'>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <Link className="navbar-brand">
            <img src={logowide} />
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <div className='page-heading-header me-auto'>
              <h1 className='m-0'>{heading}</h1>
            </div>
            <div className='d-flex gap-3 align-items-center bell-btn'>
              {/* <div className="btn btn-icon">
                <i className='ti ti-bell'></i>
              </div> */}
              <div className="dropdown profile-dropdown">
                <button className="dropdown-toggle flex-column" type="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <div className='avatar avatar-sm'>
                    <img src={centerUserData.profile_image} alt='profile-img' />
                  </div>
                  <span>{capitalizeFirstLetter(centerUserData.name)}</span>
                  <i className='ti ti-chevron-down'></i>
                </button>
                <ul className="dropdown-menu">
                  {/* <div className='profile-drop-head-out'>
                <div className='profile-drop-head'>
                  <figure className='mx-auto avatar avatar-xs'>
                    <img src={centerUserData.profile_image} alt='profile-img' />
                  </figure>
                  <figcaption>
                    <h4>{centerUserData.first_name}</h4>
                    <p>{centerUserData.email}</p>
                  </figcaption>
                </div>
              </div> */}
                  {/* <li>
                <Link to={`/center/profile`} className="dropdown-item"><svg width="24" height="24"
                  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H14C15.0609 15 16.0783 15.4214 16.8284 16.1716C17.5786 16.9217 18 17.9391 18 19V21M8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7Z"
                    stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>{t("center.header.link_my_profile")}</Link>
              </li>
              <li>
                <Link className="dropdown-item" to={`/center/profile/center-profile`}> <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 21H21M3 7V8C3 8.79565 3.31607 9.55871 3.87868 10.1213C4.44129 10.6839 5.20435 11 6 11C6.79565 11 7.55871 10.6839 8.12132 10.1213C8.68393 9.55871 9 8.79565 9 8M3 7H21M3 7L5 3H19L21 7M9 8V7M9 8C9 8.79565 9.31607 9.55871 9.87868 10.1213C10.4413 10.6839 11.2044 11 12 11C12.7956 11 13.5587 10.6839 14.1213 10.1213C14.6839 9.55871 15 8.79565 15 8M15 8V7M15 8C15 8.79565 15.3161 9.55871 15.8787 10.1213C16.4413 10.6839 17.2044 11 18 11C18.7956 11 19.5587 10.6839 20.1213 10.1213C20.6839 9.55871 21 8.79565 21 8V7M5 21V10.85M19 21V10.85M9 21V17C9 16.4696 9.21071 15.9609 9.58579 15.5858C9.96086 15.2107 10.4696 15 11 15H13C13.5304 15 14.0391 15.2107 14.4142 15.5858C14.7893 15.9609 15 16.4696 15 17V21" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>{t("Center Profile")}</Link>
              </li>
              <li>
                <Link className="dropdown-item" to="/center/profile/change-password"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5Z" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M17 22H7C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22Z" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>{t("center.header.change_password")}</Link>
              </li> */}
                  <li>
                    <Link className="dropdown-item" onClick={(e) => {
                      e.preventDefault(); logOutCenter(ROLE.CENTER)
                    }}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 8V6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H12C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18V16M7 12H21M21 12L18 9M21 12L18 15" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>{t("center.header.label_logout")}</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}